<app-header></app-header>
<div class="container-fluid" [style.font-family]="'var(--vex-font)'" style="background-image: url('assets/images/blue-gradient-image.png')">
  <div class="container py-24">
    <p class="text-center text-5xl font-bold text-white">ORBIT</p>
    <p class="pt-8 text-3xl text-center font-bold text-white">Terms of Use and Privacy Policy</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-xl text-zinc-700">Welcome to ORBIT – the advanced Office Management ERP developed by Volmint Technologies.
      By accessing and using ORBIT, you agree to comply with the following Terms of Use and Privacy Policy.
      These terms are designed to ensure secure, efficient, and transparent usage of ORBIT ERP, covering
      how we handle your information, responsibilities of users, and the protection of your data.</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container bg-heading rounded-2xl p-8">
    <p class="text-3xl text-white text-center">Please be informed that your privacy is always our priority!</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">1. Information We May Collect</p>
    <p class="pt-6 text-xl text-zinc-700">      To deliver the best possible ERP experience, ORBIT may collect the following types of information:
    </p>

    <ul class="list-disc pt-8 text-zinc-700">
      <li><p class="text-xl"><b>Account Information:</b> Name, email address, contact number, organization details, and login credentials for secure access.</p>
      </li>
      <li><p class="text-xl"><b>Operational Data:</b> Attendance, payroll, employee records, departmental workflows, communications, and documents as entered by users.</p>
      </li>
      <li><p class="text-xl"><b>System & Usage Data:</b> Device details, browser type, IP address, and activity logs to improve performance and security.</p>
      </li>
      <li><p class="text-xl"><b>Cookies & Analytics:</b> Data collected through cookies and similar technologies to monitor usage and enhance your experience.</p>
      </li>
    </ul>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">2. How We Use Your Information</p>
    <p class="pt-6 text-xl text-zinc-700">The information collected through ORBIT is used only for legitimate business and operational purposes.
      Specifically, we use your data to:</p>

    <ul class="list-disc pt-8 text-zinc-700">
      <li><p class="text-xl">Provide secure access to ERP features and role-based dashboards.</p>
      </li>
      <li><p class="text-xl">Support HR, payroll, attendance, and workflow automation.</p>
      </li>
      <li><p class="text-xl">Enable communication, collaboration, and document sharing within your organization.</p>
      </li>
      <li><p class="text-xl">Generate accurate reports, insights, and analytics for better decision-making.</p>
      </li>
      <li><p class="text-xl">Maintain security, compliance, and overall system reliability.</p>
      </li>
    </ul>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">3. Sharing Your Information</p>
    <p class="pt-6 text-xl text-zinc-700">      ORBIT respects your privacy. We do not sell or rent your information. We may share data only in the following cases:
    </p>
    <ul class="list-disc pt-8 text-zinc-700">
      <li><p class="text-xl">With your consent for authorized business purposes.</p></li>
      <li><p class="text-xl">To comply with applicable laws or government regulations.</p></li>
      <li><p class="text-xl">With trusted service providers who help us operate ORBIT, under strict confidentiality agreements.</p></li>
    </ul>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">4. Security of Your Information</p>
    <p class="pt-6 text-xl text-zinc-700">Protecting your data is our top priority. ORBIT uses encryption, firewalls, secure servers, and access controls
      to prevent unauthorized access, misuse, or loss of information. While we take every precaution,
      users are also responsible for safeguarding their login credentials.</p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">5. User Responsibilities</p>
    <p class="pt-6 text-xl text-zinc-700">      By using ORBIT, you agree to:
    </p>
    <ul class="list-disc pt-8 text-zinc-700">
      <li><p class="text-xl">Provide accurate and lawful information.</p></li>
      <li><p class="text-xl">Keep your account credentials confidential.</p></li>
      <li><p class="text-xl">Not misuse or attempt to disrupt ERP operations.</p></li>
      <li><p class="text-xl">Comply with your organization’s policies and applicable laws.</p></li>
    </ul>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">6. Data Retention</p>
    <p class="pt-6 text-xl text-zinc-700"> We retain data only for as long as necessary to provide ERP services, meet legal obligations,
      or fulfill business requirements. If you request deletion of your data, certain records may still
      be preserved as required by law.</p>

  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4 text-justify">
    <p class="text-3xl font-semibold">7. Updates to Terms</p>
    <p class="pt-6 text-xl text-zinc-700">Volmint Technologies may update these Terms of Use and Privacy Policy from time to time.
      Any significant changes will be communicated through the platform or via email notifications.
    </p>
  </div>
</div>

<div class="container-fluid mt-10 md:mt-12" [style.font-family]="'var(--vex-font)'">
  <div class="container p-4">
    <p class="text-3xl font-semibold">8. Contact Us</p>
    <p class="pt-6 text-xl text-zinc-700"> If you have any questions or concerns regarding ORBIT’s Terms of Use and Privacy Policy,
      please contact our support team at
      <a href="mailto:support@volmint.com"><u class="font-semibold">support&#64;volmint.com</u></a>.</p>
  </div>
</div>


<div class="above-footer mt-10 md:mt-12 py-12" [style.font-family]="'var(&#45;&#45;vex-font)'">
  <div class="container">
    <div class="m-auto text-center">
      <img src="./assets/images/img-group.png" alt="" class="mx-auto">
      <h3 class="mt-5 text-white text-xl font-medium">
        Need any further assistance?
      </h3>
      <p class="mt-4 text-white ">
        Our team is here to help you with ORBIT ERP anytime.
      </p>
      <button type="button" class="mt-5 px-3 py-2 bg-white text-[#6752A9] rounded" (click)="goTo('/contact-us')">
        Contact Support
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>
